import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { siteConfig } from "../config/siteConfig";
import "../css/paysuccess.css";

function PaySuccess() {
  const [params] = useSearchParams();
  const succeeded = params.get("state") === "success";

  return (
    <main id="main-content" className="order-success">
      <section
        className="order-success__panel"
        role="status"
        aria-live="polite"
        aria-labelledby="order-success-title"
      >
        <div className="order-success__mark" aria-hidden="true">
          <svg viewBox="0 0 48 48" focusable="false">
            <path d="M10 25.5 19.5 35 39 14" />
          </svg>
        </div>
        <p className="order-success__eyebrow">{succeeded ? "Payment complete" : "Payment cancelled"}</p>
        <h1 id="order-success-title">{succeeded ? "Thank you." : "Your payment was not completed."}</h1>
        <p className="order-success__message">
          {succeeded
            ? `Your payment was successful. ${siteConfig.brandName} will send your order confirmation to the email supplied at checkout.`
            : "No charge was completed. Your basket is still available if you would like to try again."}
        </p>
        <p className="order-success__note">
          For help with a payment or order, contact{" "}
          <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>
          {" "}as soon as possible.
        </p>
        <div className="order-success__actions">
          <Link className="order-success__primary" to={succeeded ? "/shop" : "/checkout"}>
            {succeeded ? "Continue shopping" : "Return to checkout"} <span aria-hidden="true">→</span>
          </Link>
          <Link className="order-success__secondary" to="/shipping">
            Shipping information
          </Link>
        </div>
      </section>
    </main>
  );
}

export default PaySuccess;
